import React from "react";
import Pagination from "./Pagination";

const OrderTable = ({ data, currentPage, totalPages, onPageChange }) => {
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-gray-700 text-white rounded-lg">
                <thead>
          <tr className="text-left border-b border-gray-600">
            <th className="px-4 py-3">Order Id</th>
            <th className="px-4 py-3">Customer Name</th>
            <th className="px-4 py-3">Total Amount</th>
            <th className="px-4 py-3">Payment Status</th>
            <th className="px-4 py-3">Order Status</th>
            <th className="px-4 py-3">Actions</th>
          </tr>
        </thead>
        <tbody>
          {data && data.length > 0 ? (
            data.map((item, index) => (
              <tr key={item.id} className="border-b border-gray-600 hover:bg-gray-600 transition">
                <td className="px-4 py-3">{item.orderId}</td>
                <td className="px-4 py-3">{item.customer_name}</td>
                <td className="px-4 py-3">{item.amount}</td>
                <td className="px-4 py-3">
                 <span
                    className={`p-2 rounded ${item.payment_status === "Paid" ? "bg-green-500" : "bg-yellow-500"} text-white`}
                  >
                    {item.payment_status}
                  </span>
                  </td>
                  <td className="px-4 py-3">
                 <span
                    className={`p-2 rounded ${item.order_status === "Confirmed" ? "bg-green-500" : "bg-yellow-500"} text-white`}
                  >
                    {item.order_status}
                  </span>
                  </td>
                <td className="px-4 py-3 flex gap-2">
                  <button className="px-2 py-1 bg-blue-500 rounded hover:bg-blue-600">Edit</button>
                  <button className="px-2 py-1 bg-red-500 rounded hover:bg-red-600">Delete</button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={5} className="text-center py-4">
                No data found.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination */}
      <div className="mt-4 flex justify-center">
        <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={onPageChange} />
      </div>
    </div>
  );
};

export default OrderTable;
